import api from 'shared/api'

const FETCH_REQUEST = 'minorGovernmentExecutives/FETCH_REQUEST';
const FETCH_SUCCESS = 'minorGovernmentExecutives/FETCH_SUCCESS';
const FETCH_MINOR_GOVERNMENT_SUCCESS = 'minorGovernmentExecutives/FETCH_MINOR_GOVERNMENT_SUCCESS';
const FETCH_FAILURE = 'minorGovernmentExecutives/FETCH_FAILURE';

const initialState = {
  minorGovernments: [],
  loadedMinorGovernments: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  errors: []
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchMinorGovernmentSuccess(payload) {
  return {
    type: FETCH_MINOR_GOVERNMENT_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadMinorGovernment(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const loadedIds = state.minorGovernments.loadedIds ? state.minorGovernments.loadedIds.slice() : [];
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }));

    return api(`api/v1/other_governments/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchMinorGovernmentSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      });
  }
}

export function loadMinorGovernments(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api('api/v1/other_governments', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      });
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        minorGovernments: [...payload]
      });
    case FETCH_MINOR_GOVERNMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedMinorGovernments: [
          ...state.loadedMinorGovernments,
          payload
        ]
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state
  }
}

